import enumeraciones from '@/../static/js/enumeraciones'
import comun from '@/../static/js/comun'
import api from '@/../static/js/api'
import router from '@/../src/router/index'
import axios from 'axios'

let state ={
    ArchivoJudicial_Catalogos_001Areas:[],
    ArchivoJudicial_Catalogos_004TipoEstatusVolumen: [],
    ArchivoJudicial_Catalogos_003TipoEstatusDocumento: [],
    ArchivoJudicial_Catalogos_012SedesArchivo: [],
    ArchivoJudicial_Catalogos_014TipoEstatusReferencia: [],
    ArchivoJudicial_Catalogos_016AreasExternas: [],
}


let mutations = {
    M_ArchivoJudicial_Catalogos_001Area(state, data) {
        state.ArchivoJudicial_Catalogos_001Areas[data.llave] = data.valor;
        },
    M_ArchivoJudicial_Catalogos_004TipoEstatusVolumen(state, data){
        state.ArchivoJudicial_Catalogos_004TipoEstatusVolumen[data.llave] = data.valor;
    },
    M_ArchivoJudicial_Catalogos_003TipoEstatusDocumento(state, data){
        state.ArchivoJudicial_Catalogos_003TipoEstatusDocumento[data.llave]= data.valor;
    },
    M_ArchivoJudicial_Catalogos_012SedesArchivo(state, data){
        state.ArchivoJudicial_Catalogos_012SedesArchivo[data.llave]= data.valor;
    },
    M_ArchivoJudicial_Catalogos_014TipoEstatusReferencia(state, data){
        state.ArchivoJudicial_Catalogos_014TipoEstatusReferencia[data.llave]= data.valor;
    },
    M_ArchivoJudicial_Catalogos_016AreasExternas(state, data){
        state.ArchivoJudicial_Catalogos_016AreasExternas[data.llave]= data.valor;
    }
}
let actions = {
    A_ArchivoJudicial_Catalogo_Establecer001Area: ({ commit }, data) => {
        commit('M_ArchivoJudicial_Catalogos_001Area', data); },
    A_ArchivoJudicial_Catalogo_Establecer004TipoEstatusVolumen: ({commit}, data) =>
        {commit('M_ArchivoJudicial_Catalogos_004TipoEstatusVolumen', data);},
    A_ArchivoJudicial_Catalogo_Establecer003TipoEstatusDocumento: ({commit}, data) =>
        {commit('M_ArchivoJudicial_Catalogos_003TipoEstatusDocumento', data);},
    A_ArchivoJudicial_Catalogo_Establecer012SedesArchivo: ({commit}, data) =>
        {commit('M_ArchivoJudicial_Catalogos_012SedesArchivo', data);},
    A_ArchivoJudicial_Catalogo_Establecer014TipoEstatusReferencia: ({commit}, data) =>
        {commit('M_ArchivoJudicial_Catalogos_014TipoEstatusReferencia', data);},
    A_ArchivoJudicial_Catalogo_Establecer016AreasExternas: ({commit}, data) =>
        {commit('M_ArchivoJudicial_Catalogos_016AreasExternas', data);}
}
const ArchivoJudicial={
    State: state,
    Mutations: mutations,
    Actions: actions
}
export default ArchivoJudicial



// WEBPACK FOOTER //
// ./src/store/ArchivoJudicial.js